import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const AngleLeft = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3 12L14.8 8.5C15.2 8.1 15.2 7.5 14.8 7.1C14.4 6.7 13.8 6.7 13.4 7.1L9.2 11.3C8.8 11.7 8.8 12.3 9.2 12.7L13.4 16.9C13.6 17.1 13.8 17.2 14.1 17.2C14.4 17.2 14.6 17.1 14.8 16.9C15.2 16.5 15.2 15.9 14.8 15.5L11.3 12Z"
      fill="currentColor"
    />
  </svg>
)

export default AngleLeft
